import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react"
import { getDeliveryApiBaseUrl } from "src/utils/apiUtils"
import { getAuth0 } from "src/utils/auth0Utils"

const BASE_URL = getDeliveryApiBaseUrl()

const customBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const rawBaseQuery = fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: async (headers) => {
      headers.set("Content-Type", "application/json; charset=utf-8")
      headers.set("ts", Date.now().toString())

      try {
        const auth0 = getAuth0()
        const token = await auth0.getAccessTokenSilently({
          authorizationParams: {
            audience: "mbls-global-api",
          },
        })

        if (token) {
          headers.set("Authorization", `Bearer ${token}`)
          headers.set("ts", `${Date.now()}`)
        }
      } catch (error) {
        console.error("Error fetching Auth0 token:", error)
      }

      return headers
    },
  })
  try {
    const result = await rawBaseQuery(args, api, extraOptions)

    // Log dev trace IDs so Playwright can read them from console
    if (import.meta.env.DEV) {
      const meta = result.meta as any
      const resp = meta?.response as Response | undefined
      const traceId = resp?.headers?.get("x-mbls-dev-trace-id")
      if (traceId) {
        const url = meta?.request?.url ?? (typeof args === "string" ? args : args.url)
        console.log(`[devtrace] ${url} ${traceId}`)
      }
    }

    if (
      result?.error?.status === 401 ||
      result?.error?.status === "FETCH_ERROR"
    ) {
      try {
        // Could redirect to Auth0 login
      } catch (e) {
        window.location.href = "/login"
      }
    }
    return result
  } catch (error) {
    console.error("Error in rawBaseQuery:", error)
    throw error
  }
}

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({}),
})
